import { System } from '@ecs/System';
import { Position } from '@components/Position';
import { Velocity } from '@components/Velocity';
import { MineLayer } from '@components/MineLayer';
import { Collider } from '@components/Collider';
import { Tag } from '@components/Tag';
import { EntityFactory } from '@entities/EntityFactory';
import { WeaponUtils } from '@utils/WeaponUtils';
import { Effects } from '@/effects/Effects';

export class MineLayerSystem extends System {
  private canvas!: HTMLCanvasElement;

  setCanvas(canvas: HTMLCanvasElement): void {
    this.canvas = canvas;
  }

  update(_deltaTime: number): void {
    const currentTime = Date.now();
    const hasPlayers = this.getEntitiesWithComponents(Tag).some(e => e.getComponent(Tag)!.value === 'player');
    if (!hasPlayers) return;

    for (const layer of this.getEntitiesWithComponents(Position, Velocity, MineLayer, Tag)) {
      if (layer.getComponent(Tag)!.value !== 'enemy') continue;

      const position = layer.getComponent(Position)!;
      const velocity = layer.getComponent(Velocity)!;
      const bay = layer.getComponent(MineLayer)!;

      if (currentTime - bay.lastDrop < bay.cooldown) continue;
      if (!WeaponUtils.isInViewport(position, this.canvas)) continue;

      // Forget mines that have been destroyed or expired
      bay.mineIds = bay.mineIds.filter(id => {
        const mine = this.world.getEntity(id);
        return mine !== undefined && !this.world.isPendingRemoval(mine);
      });
      if (bay.mineIds.length >= bay.maxActiveMines) continue;

      const offset = (layer.getComponent(Collider)?.radius ?? 10) + 4;
      const x = position.x - Math.cos(velocity.angle) * offset;
      const y = position.y - Math.sin(velocity.angle) * offset;
      const mine = EntityFactory.createMine(x, y, bay.mineDamage, bay.mineLifetime);
      this.world.addEntity(mine);
      bay.mineIds.push(mine.id);
      bay.lastDrop = currentTime;

      Effects.shieldRipple(this.world, x, y, velocity.angle + Math.PI, '#ffd11a');
    }
  }
}
